import React from 'react';
import { Row, Col } from 'reactstrap';

interface AmenityItem {
  id: string;
  amenity_name: string;
  amenity_type: string;
  amenity_class: string;
  createdAt: string;
  updatedAt: string;
}

interface PropertyAmenitiesProps {
  propertyAmenitiesData: AmenityItem[];
}

const PropertyAmenities: React.FC<PropertyAmenitiesProps> = ({ propertyAmenitiesData }) => {
  if (!propertyAmenitiesData || propertyAmenitiesData.length === 0) {
    return (
      <div className="rounded p-4 text-center mb-1">
        <span className="text-muted">No Amenities Available</span>
      </div>
    );
  }

  // Split amenities into rows of 3
  const rows = [];
  for (let i = 0; i < propertyAmenitiesData.length; i += 3) {
    rows.push(propertyAmenitiesData.slice(i, i + 3));
  }

  return (
    <div>
      {rows.map((row, idx) => (
        <Row className="mb-2" key={idx}>
          {row.map((amenity, j) => (
            <Col md={4} key={amenity.id || j} className="d-flex align-items-center mb-2">
              <i className="ri-check-line me-2" style={{ fontSize: 20, color: "#555" }}></i>
              <span style={{ fontSize: 15 }}>{amenity.amenity_name}</span>
            </Col>
          ))}
        </Row>
      ))}
    </div>
  );
};

export default PropertyAmenities;